/* ==========================================================================
   Product page — two small behaviours that belong to this template only.

   1. Review-count link. The rating row points at the review widget. The
      destination is resolved at click time rather than hard-coded, because the
      app block's generated id changes if the block is removed and re-added.
      The header is sticky, so the scroll stops short of it.

   2. Gallery arrows. The arrows added to sv-gallery.liquid drive the existing
      dot buttons instead of the track, so slide position, thumbnail
      highlighting, scroll-snap and keyboard support all keep running through
      the gallery logic already in sv-theme.js. Nothing here duplicates it.
   ========================================================================== */
(function () {
  'use strict';

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---------- 1. Review-count link ---------- */

  function reviewsTarget() {
    var own = document.getElementById('sv-reviews');
    if (own) return own;

    var loox = document.querySelector(
      '#looxReviews, [id^="looxReviews"], .loox-reviews, .loox-reviews-default, [class*="loox-"]'
    );
    if (!loox) return null;
    return loox.closest('.shopify-section') || loox;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#sv-reviews"], a[href="#looxReviews"]');
    if (!link) return;

    var target = reviewsTarget();
    if (!target) return; // nothing to scroll to — leave the link as it was

    e.preventDefault();
    var header = document.querySelector('.sv-header-wrap');
    var offset = (header ? header.offsetHeight : 0) + 12;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  /* ---------- 2. Gallery arrows ---------- */

  function dotsOf(gallery) {
    return $$('[data-sv-dot]', gallery);
  }

  function currentIndex(dots) {
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  // An arrow at the end of the run is dimmed and taken out of the tab order
  // rather than wrapping round, so the arrows always report where you are.
  function syncArrows(gallery) {
    var dots = dotsOf(gallery);
    if (!dots.length) return;
    var i = currentIndex(dots);
    var prev = gallery.querySelector('[data-sv-gallery-prev]');
    var next = gallery.querySelector('[data-sv-gallery-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= dots.length - 1;
  }

  function initGalleryArrows() {
    $$('[data-sv-gallery]').forEach(function (gallery) {
      if (gallery.dataset.svArrows) return;
      var dots = dotsOf(gallery);
      if (dots.length < 2) return;
      gallery.dataset.svArrows = '1';

      gallery.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-sv-gallery-prev], [data-sv-gallery-next]');
        if (!btn || btn.disabled) return;
        var step = btn.hasAttribute('data-sv-gallery-next') ? 1 : -1;
        var i = currentIndex(dots) + step;
        if (i < 0 || i > dots.length - 1) return;
        dots[i].click();
      });

      // sv-theme.js flips aria-current on the dots as the track settles, from
      // its own IntersectionObserver as well as from clicks, so watching the
      // attribute keeps the arrows correct however the slide was changed.
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () { syncArrows(gallery); });
        dots.forEach(function (d) {
          mo.observe(d, { attributes: true, attributeFilter: ['aria-current'] });
        });
      }

      syncArrows(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }
  document.addEventListener('shopify:section:load', initGalleryArrows);
})();
